import { render, staticRenderFns } from "./PlayerBlock.vue?vue&type=template&id=a0ef5978&"
import script from "./PlayerBlock.vue?vue&type=script&lang=js&"
export * from "./PlayerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports